import {
  isRmaLgmCommodityCode,
  isRmaLrpCommodityCode,
  RmaLgmCommodityCodeByName,
  RmaLgmCommodityNameByCode,
  RmaLrpCommodityCodes,
  RmaLrpCommodityNameByCode,
} from '@harvestiq/constants'
// eslint-disable-next-line import/no-unresolved

export const lgmCattleOptions = ['Calf Finishing', 'Yearling Finishing']
export const lgmSwineOptions = [
  'Finishing Operation',
  'SEW Operation',
  'Farrow to Finish',
]

export const cattleOptions = lgmCattleOptions.map(
  option => `Cattle - ${option}`,
)
const swineOptions = lgmSwineOptions.map(option => `Swine - ${option}`)

export const commodityTypeOptions = [...cattleOptions, ...swineOptions]

export const finishingTypeOptionMap = [
  ...cattleOptions,
  ...swineOptions,
].reduce((acc, crr) => {
  const [_, val] = crr.split(' - ')
  acc[crr] = val
  return acc
}, {})

export const getCommodityCode = commodityType => {
  // Extract the commodity from the type
  const commodityName = commodityType.split(' - ')[0]
  const commodityCode = RmaLgmCommodityCodeByName[commodityName]
  return commodityCode
}

export const makeCoverageCommodityLabel = (commodityCode, commodityType) => {
  if (isRmaLrpCommodityCode(commodityCode)) {
    const commodityName = RmaLrpCommodityNameByCode[commodityCode]
    return `${commodityName} - ${commodityType}`
  }
  if (isRmaLgmCommodityCode(commodityCode)) {
    const commodityName = RmaLgmCommodityNameByCode[commodityCode]
    return `${commodityName} - ${commodityType}`
  }

  return commodityType
}

export const numberOfHeadParameters = {
  limit: {
    [RmaLrpCommodityCodes.SWINE]: 70000,
    [RmaLrpCommodityCodes.FED_CATTLE]: 12000,
    [RmaLrpCommodityCodes.FEEDER_CATTLE]: 12000,
  },
  helperText: {
    [RmaLrpCommodityCodes.SWINE]: 'Swine max limit is 70,000',
    [RmaLrpCommodityCodes.FED_CATTLE]: 'Fed Cattle max limit is 12,000',
    [RmaLrpCommodityCodes.FEEDER_CATTLE]: 'Feeder Cattle max limit is 12,000',
  },
}

// eslint-disable-next-line import/no-extraneous-dependencies
export { commodityTypeOptionsByCommodityName } from '@harvestiq/iiq-common/lgm/commodity-type-options-by-commodity-name'

// eslint-disable-next-line import/no-extraneous-dependencies
export { getMarketingMonths } from '@harvestiq/iiq-common/lgm/get-marketing-months'
